(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dual-blog-grid"] && !Shopify.designMode) return;
  try {
    
  const initializeDynamicBlog = (scope = document) => {
    scope.querySelectorAll('[data-dynamic-blog]').forEach((section) => {
      if (section.dataset.dynamicBlogReady === 'true') return;

      const track = section.querySelector('[data-blog-track]');
      const previous = section.querySelector('[data-blog-previous]');
      const next = section.querySelector('[data-blog-next]');
      const toggle = section.querySelector('[data-blog-toggle]');

      if (!track || !previous || !next) return;

      const autoplayEnabled = section.dataset.autoplay === 'true';
      const autoplaySpeed = Number.parseInt(section.dataset.autoplaySpeed, 10) || 6000;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let autoplayTimer;
      let autoplayPaused = false;

      const stepSize = () => {
        const card = track.querySelector('[data-blog-card]');
        if (!card) return track.clientWidth;
        const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const updateControls = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum - 2;
      };

      const moveAutomatically = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        if (track.scrollLeft >= maximum - 2) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }
        track.scrollBy({ left: stepSize(), behavior: 'smooth' });
      };

      const stopAutoplay = () => {
        window.clearInterval(autoplayTimer);
      };

      const startAutoplay = () => {
        stopAutoplay();
        if (!autoplayEnabled || autoplayPaused || prefersReducedMotion) return;
        if (track.querySelectorAll('[data-blog-card]').length < 2) return;
        autoplayTimer = window.setInterval(moveAutomatically, autoplaySpeed);
      };

      const resetAutoplay = () => {
        stopAutoplay();
        startAutoplay();
      };

      previous.addEventListener('click', () => {
        track.scrollBy({ left: -stepSize(), behavior: 'smooth' });
        resetAutoplay();
      });

      next.addEventListener('click', () => {
        track.scrollBy({ left: stepSize(), behavior: 'smooth' });
        resetAutoplay();
      });

      if (toggle) {
        toggle.addEventListener('click', () => {
          autoplayPaused = !autoplayPaused;
          toggle.setAttribute('aria-pressed', String(autoplayPaused));
          toggle.setAttribute(
            'aria-label',
            autoplayPaused ? section.dataset.playLabel : section.dataset.pauseLabel
          );
          toggle.querySelector('[data-pause-icon]').hidden = autoplayPaused;
          toggle.querySelector('[data-play-icon]').hidden = !autoplayPaused;

          if (autoplayPaused) stopAutoplay();
          else startAutoplay();
        });
      }

      track.addEventListener('scroll', updateControls, { passive: true });
      track.addEventListener('pointerdown', stopAutoplay, { passive: true });
      track.addEventListener('pointerup', startAutoplay, { passive: true });
      track.addEventListener('pointercancel', startAutoplay, { passive: true });
      track.addEventListener('touchend', startAutoplay, { passive: true });
      if (window.matchMedia('(hover: hover)').matches) {
        section.addEventListener('mouseenter', stopAutoplay);
        section.addEventListener('mouseleave', startAutoplay);
      }
      section.addEventListener('focusin', stopAutoplay);
      section.addEventListener('focusout', startAutoplay);
      window.addEventListener('resize', updateControls);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      });
      section.dataset.dynamicBlogReady = 'true';
      updateControls();
      startAutoplay();
    });
  };

  initializeDynamicBlog();
  document.addEventListener('shopify:section:load', (event) => initializeDynamicBlog(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
